import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { isChurchPublicPath } from "@/lib/church-public-routes";

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
  }
}

export function usePageTracking() {
  const location = useLocation();

  // O snippet de injeção do Pixel (analytics-loader.tsx) já dispara um
  // PageView para a tela em que o script entrou. Se disparássemos também na
  // primeira execução deste efeito, a tela de entrada contaria duas vezes.
  const isFirstRun = useRef(true);

  useEffect(() => {
    const consent = localStorage.getItem("ecclesiato-cookie-consent");
    if (consent !== "accepted") return;
    // Página pública de igreja: sem PageView para o Pixel e o GA do Ecclesiato
    // (ver church-public-routes.ts). O DataFast segue, por fora daqui.
    if (isChurchPublicPath(location.pathname)) return;

    // O Pixel dispara PageView uma única vez, quando o script é injetado.
    // Como o app é uma SPA, toda navegação interna depois disso ficava
    // invisível para a Meta — e público personalizado por URL ("visitou
    // /pricing") nunca enchia. O disparo manual resolve.
    if (isFirstRun.current) {
      isFirstRun.current = false;
    } else if (typeof window.fbq === "function") {
      window.fbq("track", "PageView");
    }

    if (typeof window.gtag === "function") {
      const gaId = import.meta.env.VITE_GA_MEASUREMENT_ID;
      
      // Envia evento de visualização de página para o GA4
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
        send_to: gaId || import.meta.env.VITE_GADS_ID // Fallback para GAds se GA4 não estiver setado
      });

      // Também empurra para o GTM DataLayer se ele existir
      if (window.dataLayer) {
        window.dataLayer.push({
          event: "page_view",
          page_path: location.pathname + location.search,
        });
      }
    }
  }, [location]);
}
